import React, { useEffect, useState } from "react";
import { MyContext } from "../../context";
import { mergeStyleSets, Label, Checkbox, Dropdown, IconButton, TextField, TooltipHost, FontIcon } from "office-ui-fabric-react";
import UserPicker from "../ReportView/ReportConfiguration/UserPicker";

const classNames = mergeStyleSets({
    gridContainer3: {
        display: "grid",
        gridTemplateColumns: "10fr 1fr 35px ",
        alignItems: "end",
    },
    gridContainer2: {
        display: "grid",
        gridTemplateColumns: "11fr  35px",
        alignItems: "end",
    },
    trashIcon: {
        color: "red",
    },
});

const InputComponent = ({ type, style, index, data, updateElement, deleteElement, meetingSubjectDisabled, disabled }) => { //deleteElement used in case of multiple users lists
    const [state, setState] = useState({
        entries: data?.entries,
        matchMode: data?.matchMode,
        isActive: data?.isActive ?? false,
    });

    // Ensure isActive is false if disabled is true (for meeting attendees and organizers)
    useEffect(() => {
        if (disabled && state.isActive) {
            setState((prevState) => ({
                ...prevState,
                isActive: false,
            }));
        }
        // Only run when 'disabled' changes
    }, [disabled]);

    const updateState = (key, value) => {
        setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const getKey = (type) => {
        switch (type) {
            case "participants":
                return "participantsList";
            case "callQueue":
                return "callQueueList";
            case "meetingOrganizers":
                return "meetingOrganizersList";
            case "meetingAttendees":
                return "meetingAttendeesList";
            case "meetingSubject":
                return "meetingSubjectList";
            default:
                return;
        }
    };

    useEffect(() => {
        updateElement(getKey(type), index, state);
    }, [state]);

    return (
        <MyContext.Consumer>
            {(context) => (
                <div
                    style={{ ...style, gap: "20px" }}
                    className={classNames.gridContainer3}
                >
                    <div style={{ width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                            <Checkbox
                                checked={state.isActive}
                                onChange={(e, checked) => updateState("isActive", checked)}
                                styles={{ root: { marginRight: 8 } }}
                                disabled={disabled}
                            />

                            {/*index used for multiple user lists*/}

                            <Label style={{ margin: 0 }}>
                                {context.getTranslation("recordingRule", getKey(type))} {index > 1 && `#${index}`}
                            </Label>
                        </div>
                        {type !== "meetingSubject" ? (<>

                            <UserPicker
                                disabled={!state.isActive}
                                placeholder={type === "callQueue" ? context.getTranslation("configuration", "typeCallQueueUsername") : context.getTranslation("common", "multiSelectPlaceholder")}
                                isAllowList={true}
                                user={state.entries}
                                fc={(user) => {
                                    updateState("entries", user);
                                }}

                            />
                        </>) : (
                            <TextField
                                value={state.entries}
                                placeholder={context.getTranslation("recordingRule", "meetingSubjectPlaceholder")}
                                disabled={!state.isActive}
                                onChange={(event, newValue) => {
                                    updateState("entries", newValue);
                                }}
                            />
                        )}
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Dropdown
                            style={{ width: "150px" }}
                            selectedKey={state.matchMode}
                            options={[
                                { key: "Match", text: context.getTranslation("recordingRule", "match") },
                                { key: "NotMatch", text: context.getTranslation("recordingRule", "notMatch") },
                            ]}
                            onChange={(event, newValue) => {
                                updateState("matchMode", newValue.key);
                            }}
                            disabled={!state.isActive}

                        />
                        <TooltipHost
                            content={
                                type === "meetingSubject"
                                    ? (state.matchMode === "Match"
                                        ? context.getTranslation("recordingRule", "matchTooltipMeetingSubject")
                                        : context.getTranslation("recordingRule", "noMatchTooltipMeetingSubject"))
                                    : (state.matchMode === "Match"
                                        ? context.getTranslation("recordingRule", "matchTooltip")
                                        : context.getTranslation("recordingRule", "noMatchTooltip"))
                            } styles={{ root: { marginLeft: 6 } }}
                        >
                            <FontIcon iconName="Info" style={{ cursor: 'pointer', fontSize: 14 }} />
                        </TooltipHost>
                    </div>

                    {/*used for multiple user lists*/}

                    {/*{index > 1 && (*/}
                    {/*    <IconButton*/}
                    {/*        iconProps={{ iconName: "Delete" }}*/}
                    {/*        className={classNames.trashIcon}*/}
                    {/*        onClick={() => {*/}
                    {/*            deleteElement(getKey(type), index);*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*)}*/}
                </div>
            )}
        </MyContext.Consumer>
    );
};

export default InputComponent;
